<template>
  <div class="insured_info_item">
    <van-cell>
      <div class="item_title_box">
        <div class="insured_index">{{ handleChinese() }}</div>
        <div class="handle_item" @click="delOne(index)">删除</div>
      </div>
    </van-cell>
    <van-field
      class="my_insured_field"
      v-model="insuredInfo.insuredName"
      name="insuredName"
      label="姓名"
      placeholder="请输入被保人姓名"
      input-align="right"
      label-class="my_insured_label"
      required
    />
    <van-field
      class="my_insured_field"
      :value="insuredInfo.insuredCertificat"
      name="insuredCertificat"
      label="证件类型"
      placeholder="请选择被保人证件类型"
      input-align="right"
      label-class="my_insured_label"
      readonly
      is-link
      required
      @click="insuredInfo.showInsuredCertificatPicker = true"
    ></van-field>
    <van-popup
      v-model="insuredInfo.showInsuredCertificatPicker"
      position="bottom"
    >
      <van-picker
        title="证件类型"
        show-toolbar
        value-key="value"
        :columns="insuredInfo.insuredCertificatTypes"
        @confirm="onInsuredCertificatTypesConfirm"
        @cancel="showInsuredCertificatPicker = false"
      />
    </van-popup>
    <van-field
      class="my_insured_field"
      v-model="insuredInfo.insuredIdCardNum"
      name="insuredIdCardNum"
      label="证件号码"
      placeholder="请输入被保人证件号码"
      input-align="right"
      label-class="my_insured_label"
	  @blur="mobileIdNumberChange(index)"
      required
    />
    <template v-if="insuredInfo.insuredCertificatId > 1">
      <van-field
        class="my_insured_field"
        v-model="insuredInfo.insuredGender"
        name="insuredGender"
        label="性别"
        placeholder="请输入手机号码"
        input-align="right"
        label-class="my_insured_label"
        required
      >
        <template #input>
          <div class="gender_box">
            <div
              :class="`gender_item ${
                +insuredInfo.insuredGender === 1 ? 'active' : ''
              }`"
              @click="insuredInfo.insuredGender = 1"
            >
              男
            </div>
            <div
              :class="`gender_item ${
                +insuredInfo.insuredGender === 2 ? 'active' : ''
              }`"
              @click="insuredInfo.insuredGender = 2"
            >
              女
            </div>
          </div>
        </template>
      </van-field>
      <van-field
        class="my_insured_field"
        v-model="insuredInfo.birthday"
        readonly
        clickable
        name="birthday"
        label="出生日期"
        placeholder="请选择出生日期"
        input-align="right"
        label-class="my_insured_label"
        required
        @click="insuredInfo.showInsuredCalendar = true"
      >
        <template #input>
          <div class="birthday">
            <div class="date_msg">
              {{ insuredInfo.birthday || '请选择出生日期' }}
            </div>
            <div class="iconfont icon-calendar icon_calendar"></div>
          </div>
        </template>
      </van-field>
      <!-- <van-calendar
        color="#28CC77"
        v-model="insuredInfo.showInsuredCalendar"
        @confirm="onInsuredCalendarConfirm"
      /> -->
      <van-popup v-model="insuredInfo.showInsuredCalendar" position="bottom">
        <van-datetime-picker
          type="date"
          v-model="insuredInfo.currentDate"
          :formatter="formatterDate"
          :min-date="insuredInfo.minDate"
          @confirm="onInsuredCalendarConfirm"
          @cancel="showInsuredCalendar = false"
        />
      </van-popup>
    </template>
  </div>
</template>

<script>
import './InsuredInfoItem.less';
import { SectionToChinese } from '../../utils/sectionToChinese'
import { Cell, Field, Picker, Popup, DatetimePicker } from 'vant';
import dayjs from '../../libs/js/day'
export default {
  name: 'InsuredInfoItem',
  data() {
    return {
    }
  },
  props: {
    insuredInfo: Object,
    index: Number,
    delOne: Function,
	mobileIdNumberChange: Function,
  },
  components: {
    'van-cell': Cell,
    'van-field': Field,
    'van-popup': Popup,
    'van-picker': Picker,
    'van-popup': Popup,
    'van-datetime-picker': DatetimePicker,
  },
  methods: {
    onInsuredCertificatTypesConfirm(value) {
      this.insuredInfo.insuredCertificat = value.value
      this.insuredInfo.insuredCertificatId = value.id
      this.insuredInfo.showInsuredCertificatPicker = false
    },
    onInsuredCalendarConfirm(date) {
      this.insuredInfo.birthday = dayjs(date).format('YYYY-MM-DD')
      this.insuredInfo.showInsuredCalendar = false
    },
    formatterDate(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    handleChinese() {
      return `被保人${SectionToChinese(this.index + 1)}`
    },
  }
}
</script>

<style>
</style>